import { VueModule } from '@Foundation/utilities';
import { logout } from './code/Scripts/directives/logout';

export default VueModule({
  directives: {
    logout
  }
});
